<template>
<m-pageframe
    title="Rate Card: {organization_label}"
>
<v-container>

    <m-settings-organization-rate-card-ctrl
        :organization_id="this.$route.params.organization_id"
    />

</v-container>
</m-pageframe>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
</style>